import React from 'react';
import './PhoneLoader.css';

export default function PhoneLoader() {
    return (
        <div className="phone-loader">
            <img
                src="https://www.svgrepo.com/show/493732/spinner-loading-dots.svg"
                alt="Cargando..."
            />
        </div>
    )
}
